/**
 * The **text** widget (`specs/M10-D2-widgets.md` §5.4).
 *
 * monday's `ExternalWidget` enum has no `TEXT` member — the text widget is an app feature — so
 * this registers under `APP_FEATURE` with `subkind: 'text'`, the only shape that survives a
 * `create_widget(kind: APP_FEATURE)` round trip. It reads no data.
 */
import { z } from 'zod';
import { defineWidget } from '../types.js';
export const textWidgetSettingsSchema = z.object({
    subkind: z.literal('text').default('text'),
    html: z.string().default(''),
    extra: z.record(z.string(), z.unknown()).default({}),
});
export const textWidget = defineWidget({
    id: 'text',
    kind: 'APP_FEATURE',
    title: 'Text',
    description: 'A note on the canvas.',
    settingsSchema: textWidgetSettingsSchema,
    defaultSettings: textWidgetSettingsSchema.parse({}),
    dataShape: 'none',
    defaultLayout: { x: 0, y: 0, w: 4, h: 3 },
    minLayout: { w: 2, h: 2 },
    requiresBoards: false,
    implemented: true,
    plannedIn: null,
    galleryOrder: 4,
    fromMondaySettings(raw) {
        const source = typeof raw === 'string' ? safeParse(raw) : (raw ?? {});
        const known = new Set(['subkind', 'html']);
        const extra = {};
        for (const [key, value] of Object.entries(source))
            if (!known.has(key))
                extra[key] = value;
        return textWidgetSettingsSchema.parse({
            subkind: 'text',
            html: typeof source['html'] === 'string' ? source['html'] : '',
            extra,
        });
    },
    toMondaySettings(settings) {
        return { subkind: 'text', html: settings.html, ...settings.extra };
    },
    dataRequest() {
        return null;
    },
});
function safeParse(raw) {
    try {
        const parsed = JSON.parse(raw);
        return parsed !== null && typeof parsed === 'object' ? parsed : {};
    }
    catch {
        return {};
    }
}
//# sourceMappingURL=index.js.map